import React, { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

interface Props {
	to?: string;
	href?: string;
	as?: string;
	target?: string;
	onClick?: any;
	blank?: boolean;
	children?: ReactNode;
}

export const asAnchor = css`
	cursor: pointer;
	color: ${props => props.theme.colors.primary};
	transition: color 200ms ease;
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};

	&:hover {
		color: ${props => props.theme.colors.primaryDark};
	}
`;

const Anchor = styled.a`
	${asAnchor}
`;

const StyledLink = styled(Link)`
	${asAnchor};
`;

export const A: FC<Props> = ({ to, children, blank, ...rest }) => {
	if (to && !to.startsWith('http')) {
		if (to && (to.endsWith('pdf') || to.endsWith('exe') || to.endsWith('zip'))) {
			return (
				<Anchor href={to} target="_blank">
					{children}
				</Anchor>
			);
		}
		return (
			<StyledLink to={to} {...rest}>
				{children}
			</StyledLink>
		);
	}
	if (to && to.startsWith('http')) {
		if (blank)
			return (
				<Anchor href={to} target="_blank" {...rest}>
					{children}
				</Anchor>
			);
		return (
			<Anchor href={to} {...rest}>
				{children}
			</Anchor>
		);
	}
	return <Anchor {...rest}>{children}</Anchor>;
};
